/**
 * Chat Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    const ChatReplacerView = require('replacers/chat/chat.view');
    const communicationApi = require('modules/api/communication.api');
    const user = require("user");
    const core = require('core');
    const config = require('config');
    const urlUtil = require('util/url.util');

    module.exports = ChatReplacerView.extend({

        render: function() {
            const isEnabled = this._isChatEnabled();
            const hideChatByUrl = urlUtil.getLocationParameterByName('hideChat') === '1';
            const shouldHideButton = !isEnabled
                || this.options.name === 'CHAT_BUTTON' && !config.get('chatWidget').showIcon
                || hideChatByUrl;
            const isLoggedIn = user?.isLoggedIn() || Playtech?.API?.auth?.isLoggedIn; /* Lugano changes */

            if (shouldHideButton) {
                return this;
            } else if (!this.subscribed) {
                this.subscribeToApiEvents();

                if(!isLoggedIn) {
                    this.$el.html(this.tmpl(this.options.name.toLowerCase(), {
                        unreadCount: 0,
                        isAdminAvailable: false,
                        isUserLogged: isLoggedIn,
                    }));
                }
            } else {
                this.$el.html(this.tmpl(this.options.name.toLowerCase(), {
                    unreadCount: this.api('getUnreadCount').adminMessagesCount,
                    isAdminAvailable: this.api('getAdminStatus').isAdminAvailable,
                    isUserLogged: user.isLoggedIn(),
                }));
            }

            return this;
        },

        handleOpenChat: function(event) {
            event.preventDefault();
            window.Playtech.API?.sidebar?.close?.(); /* Lugano changes */

            const isEnabled = this._isChatEnabled();
            const chatBtnLink = this.translate('playtech.mobile.system.header.chatBtn.link');
            const isLoggedIn = user?.isLoggedIn() || Playtech?.API?.auth?.isLoggedIn; /* Lugano changes */

            /* Lugano changes */
            if (!isLoggedIn && chatBtnLink) {
                core.navigate(chatBtnLink);
            }
            /* Lugano changes */

            if (!isEnabled) {
                return;
            }

            const windowStatus = this.api('getWindowStatus');
            const chatConfig = communicationApi('chat') && communicationApi('chat')('getConfig');

            if (windowStatus && (windowStatus.activeScreen === 'CHAT_UI__ICON' || windowStatus.hidden)) {
                chatConfig && Object.keys(chatConfig).length > 0 && this.api('maximize');
                communicationApi('inbox') && communicationApi('inbox')('minimize');
            }
        },
    });
});
